// extracted by mini-css-extract-plugin
export default {"container":"date-separated_container__2shB9","item":"date-separated_item__2Bs2B"};